import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmData } from '@macs-frontend/features/shared/components/confirm-popup/confirm-popup.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type PromptData<T> = ConfirmData<T> & {
  defaultMessage: string;
  messageRequired?: boolean;
  placeholder?: string;
  useTextarea?: boolean;
};

@Component({
  selector: 'md-prompt-popup',
  templateUrl: './prompt-popup.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromptPopupComponent {
  message = new UntypedFormControl(
    this.data.defaultMessage || '',
    this.data.messageRequired ? [Validators.required] : null,
  );
  disabled$: Observable<boolean> = this.message.valueChanges.pipe(
    map(value => !Boolean(value)),
  );

  constructor(
    public dialogRef: MatDialogRef<PromptPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PromptData<any>,
  ) {}

  close() {
    this.dialogRef.close(undefined);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(this.message.value);
  }
}
